import { DEFAULT_GRID } from "@/shared/state/visualization/schema/v1/three-d";
import type { Grid } from "@/shared/state/visualization/schema/v1/three-d";

/**
 * The preview's floor grid: the same one a 3D panel opens with.
 *
 * Takes no measurement of the model. The preview used to derive a spacing from
 * the bounding box — about five cells across the robot — and that is gone by
 * request: a grid whose spacing changes with whatever was ingested is a scale
 * reference that means something different in every dialog, and the panel's own
 * default is the one a user has already learnt to read. {@link DEFAULT_GRID} is
 * referenced rather than restated so the two cannot drift.
 *
 * `verticalOffset` is deliberately **unset**: `applyRenderOrigin` then derives
 * the grid's height from the first positioned entity, which for an imported
 * model is its root link — so the grid sits under the robot rather than at a
 * fixed zero.
 *
 * Written as an explicit `undefined` rather than omitted, which is the same
 * thing to every reader of the value and not the same thing to `lodash.isEqual`.
 * The grid editor beside the preview always produces the key, so a grid without
 * it compares unequal to the identical grid with it — and the renderer, which
 * decides whether to rebuild the grid mesh on exactly that comparison, would
 * dispose and re-mesh the floor the moment the editor mounted.
 *
 * The camera half of the preview's framing lives in
 * `shared/components/visualization/Panel/ThreeDPanel/modelFraming.ts`, which the
 * panel shares: how a converted robot is framed is a property of how this
 * platform converts URDFs and how Babylon loads glTFs, not of this wizard.
 */
export function previewGrid(): Grid {
  return { ...DEFAULT_GRID, verticalOffset: undefined };
}
